<template>
  <div class="appupload">
    <div class="tipsbox" v-if="tipshow">敬请期待</div>
    <div class="logo">
       <img src="@/assets/images/logo.png"/>
    </div>
    <div class="title">德方云居家健康APP<br/>还您健康自由</div>
    <!-- <img src="@/assets/images/upload.png" /> -->
    <div class="btnbox">
      <div class="btn appleBtn" @click='clickDown()'>
        <img src="@/assets/images/frame.png" />
        <p>苹果手机下载</p>
        <img src="@/assets/images/down.png" />
      </div>
      <div class="btn uploadBtn" @click='clickDown(1)'>
        <img src="@/assets/images/andior.png" />
        <p>安卓手机下载</p>
        <img src="@/assets/images/tips.png" />
      </div>
    </div>
    <div class="list">
      <div class="item">
        <div class="leftbox onebox">
          <img src='@/assets/images/rational.png'/>
        </div>
        <div class="rightbox">
          <div class="itemTitle">健康管理智能化</div>
          <div class="itemText">采用最先进的智能设备，全自动提取检测标本，无需人工采集。</div>
        </div>
      </div>
      <div class="item">
        <div class="leftbox twobox">
          <img src='@/assets/images/intelli.png'/>
        </div>
        <div class="rightbox">
          <div class="itemTitle">健康保健合理化</div>
          <div class="itemText">根据不同的使用场景，以干化学比色法精准识别样本。</div>
        </div>
      </div>
      <div class="item">
        <div class="leftbox threebox">
          <img src='@/assets/images/visual.png'/>
        </div>
        <div class="rightbox">
          <div class="itemTitle">健康数据可视化</div>
          <div class="itemText">采用最先进的AI智能分析系统,最快120秒高速解读健康数据，随手可查。</div>
        </div>
      </div>
      <div class="item">
        <div class="leftbox threebox">
          <img src='@/assets/images/intimate.png'/>
        </div>
        <div class="rightbox">
          <div class="itemTitle">健康建议贴心化</div>
          <div class="itemText">AI智能分析系统根据个人健康档案提供专业健康管理建议。</div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="show" @click="show=false">
      <img src="@/assets/images/tipbtn.png"/>
      <p>请在浏览器中打开~</p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.appupload {
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
  background-color: #fff;
  font-family: PingFang SC;
  background: url(../assets/images/back.png) no-repeat center top;
  background-size: 100% auto;
  background-color: #f5f5f5;
  img {
    display: block;
    width: 100%;
  }
  .logo{
    width: 192px;
    height: 192px;
    margin: 0 auto;
    padding-top: 80px;
  }
  .title{
    text-align: center;
    font-size: 48px;
    color: #fff;
    font-weight: 700;
    margin-top: 48px;
  }
  .btnbox {
    width: 686px;
    margin: 0 auto;
    line-height: 96px;
    font-size: 32px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #00CDE5;
    margin-top: 52px;
    .btn {
      height: 96px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 166px;
      border-radius: 48px;
      img{
        width: 64px;
      }
      // img {
      //   width: 64px;
      //   float: right;
      //   margin-right: 180px;
      //   margin-top: 5px;
      //   animation: mymove 1s infinite;
      //   -webkit-animation: mymove 1s infinite;
      // }
    }
    .appleBtn{
      background-color: #fff;
      a{
        color: #00CDE5;
        text-decoration: none;
      }
    }
    .uploadBtn{
      background-color: #FD9F01;
      margin-top: 32px;
      color: #FFFFFF;
    }
  }
  .list{
    // padding: 0 32px 0 8px;
    padding-bottom: 56px;
    background-color: #F5F5F5;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    // max-width: 750PX;
    margin: 0 auto;
    padding: 48px 32px;
    display: flex;
    flex-wrap:wrap;
    justify-content: space-between;
    margin-top: 48px;
    .item{
      position: relative;
      margin-bottom: 32px;
      width: 326px;
      height: 326px;
      background-color: #fff;
      border-radius: 30px;
      text-align: center;
      // align-items: center;
      .leftbox{
        margin: 0 auto;
        width: 96px;
        padding-top: 24px;
        img{
          display: block;
          width: 100%;
        }
      }
      .rightbox{
        margin-top: 24px;
        .itemTitle{
          // height: 44px;
          font-size: 28px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
        }
        .itemText{
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #666666;
          margin: 12px 18px 26px 18px;
          opacity: 0.8;
          line-height: 35px;
        }
      }
    }
  }
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    color: #fff;
    img{
      display: block;
      width: 64px;
      position: absolute;
      right: 20px;
      top: 50px;
    }
    p{
      color: #fff;
      text-align: center;
      font-size: 36px;
      margin-top:30vh;
    }
  }
  .tipsbox{
    font-size: 32px;
    position: fixed;
    width: 280px;
    background-color: rgba(0,0,0,1);
    color: #fff;
    text-align: center;
    border-radius: 10px;
    line-height: 50px;
    top: 50%;
    left: 50%;
    transform: translate(-140px,-25px);
    z-index: 500;
  }
}
@keyframes mymove {
  from {
    transform: translateY(0);
    // opacity: 0;
  }
  to {
    transform: translateY(20px);
    /* transition: 1s ease-in; */
    // opacity: 1;
  }
  /*     opacity: 1;
    transform: translateX(-140px) rotate(0); */
}
</style>

<script>
import { downloadApk } from '@/api/app'
export default {
  data() {
    return {
      show:false,
      tipshow:false
    };
  },
  methods: {
    clickDown(type) {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if(type){
        if (isWeixin) {
          console.log(isWeixin,'isWeixin')
          this.show = true
          return true;
        } else {
          console.log(isWeixin,'bushi')
        }
        downloadApk().then(res=>{
          console.log(res)
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a');
          eleLink.setAttribute("href", res.packageUpdate);
          // eleLink.setAttribute("download",name);
          eleLink.style.display = 'none';
          // 触发点击
          document.body.appendChild(eleLink);
          eleLink.click();
          // 然后移除
          document.body.removeChild(eleLink);

        })
      }else{
        if (isWeixin) {
          this.show = true
          return true;
        }
        window.location.href = 'https://itunes.apple.com/app/id1592957307'
        // const iosUrl = 'https://itunes.apple.com/app/id1592957307'
        // this.tipshow = true;
        // var eleLink = document.createElement('a');
          // eleLink.setAttribute("href", iosUrl);
          // // eleLink.setAttribute("download",name);
          // eleLink.style.display = 'none';
          // // 触发点击
          // document.body.appendChild(eleLink);
          // eleLink.click();
          // // 然后移除
          // document.body.removeChild(eleLink);
        // 
        // setTimeout(() => {
        //   this.tipshow = false;
        // }, 1000);
      }
    },
  },
};
</script>